export default "__VITE_ASSET__Dkf$Ktzh__"